const API_BASE_URL = process.env.REACT_APP_API_URL ?? '';

function mapApiError(error, fallbackMessage) {
  if (error instanceof Error && error.name === 'TypeError') {
    return new Error('Server trenutno nije dostupan. Pokušajte ponovo za nekoliko minuta.');
  }
  if (error instanceof Error) {
    return error;
  }
  return new Error(fallbackMessage);
}

export const orderService = {
  async previewOrder(cartItems, deliveryType = 'DELIVERY') {
    try {
      const payload = {
        deliveryType,
        items: cartItems.map(item => ({
          productId: item.product.id,
          quantity: item.quantity
        }))
      };

      const response = await fetch(`${API_BASE_URL}/api/order/preview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('Greška pri obracunu porudžbine');
      return await response.json();
    } catch (error) {
      throw mapApiError(error, 'Greška pri obracunu porudžbine');
    }
  },

  async createOrder(orderData) {
    try {
      const payload = {
        ...orderData,
        deliveryType: orderData.deliveryType || 'DELIVERY',
        items: (orderData.items || []).map(item => ({
          productId: item.productId,
          quantity: item.quantity
        }))
      };

      const response = await fetch(`${API_BASE_URL}/api/order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) throw new Error('Greška pri kreiranju porudžbine');
      return await response.json();
    } catch (error) {
      throw mapApiError(error, 'Greška pri kreiranju porudžbine');
    }
  }
};
